import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IReportEmbedConfiguration, models } from 'powerbi-client';
import { concatMap, from, map, Observable } from 'rxjs';
import { AuthService } from '../../../../../core/auth/auth.service';

export interface PowerBiEmbedConfig {
  embedUrl?: string;
}

export interface PowerBiEmbedData {
  config: PowerBiEmbedConfig;
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class PowerbiService {
  public regex: RegExp = /groups\/(?<groupId>[a-z0-9-]+)\/reports\/(?<reportId>[a-z0-9-]+)\//;
  private authBaseUrl: string = 'https://api.powerbi.com/v1.0/myorg';

  constructor(
    private _authService: AuthService,
    private _http: HttpClient
  ) {}

  getPowerBiEmbed(url: string): Observable<IReportEmbedConfiguration> {
    const token$: Observable<string> = from(this._authService.getPowerBiToken());

    return token$.pipe(
      concatMap(token =>
        this._http
          .get<{ embedUrl: string }>(this.getReportUrl(url), {
            headers: { Authorization: `Bearer ${token}` },
          })
          .pipe(
            map(response => ({
              type: 'report',
              embedUrl: response.embedUrl,
              tokenType: models.TokenType.Aad,
              accessToken: token,
            }))
          )
      )
    );
  }

  private getReportUrl(url: string): string {
    const matches: RegExpMatchArray | null = this.regex.exec(url);

    if (!matches) {
      throw new Error('Argument exception, malformed url');
    }

    const groupId: string = matches!.groups!['groupId'];

    if (groupId === 'me') {
      return `${this.authBaseUrl}/reports/${matches!.groups!['reportId']}`;
    }

    return `${this.authBaseUrl}/groups/${matches!.groups!['groupId']}/reports/${matches!.groups!['reportId']}`;
  }
}
